export class calculateValuesDetail {
    identifier: number;
    index: number;

}